<template>
  <div class="">
    <div class="relative">
      <div class="absolute bg-design1 mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd1.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design2 mob-hidden">
        <img src="../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
      </div>
      <div class="absolute bg-design3 mob-hidden">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
    </div>
    <div class="lg:flex md:flex">
      <img
        src="../../../assets/images/cp-bg.png"
        alt="cp bg"
        class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
      />
      <div
        class="lg:w-1/2 md:w-1/2 w-full relative md:hidden lg:hidden block lg:top-0 md:top-0 top-72"
      >
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/Shop%20page-%20banner2.jpg"
          class="w-full absolute md:hidden lg:hidden block"
          alt="swiper-img"
        />
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
        <div
          class="lg:w-5/6 md:w-5/6 ml-auto lg:pt-0 md:pt-0 pt-24 lg:px-0 md:px-0 px-6"
        >
          <p
            class="font-semibold fsize35 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
          >
            Subscribe for support & services
          </p>

          <p
            class="fsize25 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
          >
            For regular ongoing support, you may want to subscribe to our
            bundled services for additional benefits.
            <!-- 
            <a
              @click.stop="handleClick('')"
              class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
              >Know More</a
            > -->
          </p>
          <!-- <div class="flex lg:pt-8 md:pt-8 mob-hidden">
            <base-button
              @click="handleClick('register')"
              type="primary"
              class="cust-btn-wh btntext"
              >Buy Now</base-button
            >
          </div> -->
        </div>
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
        <img
          src="../../../assets/images/cp-bg.png"
          alt="cp bg"
          class="mob-hidden w-full relative h-95per bg-white"
        />
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/subscribe%20page.jpg"
          class="w-full absolute min-top8rem min-h-86per"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  data() {
    return {};
  },

  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style scoped>
@media (min-width: 1024px) {
}
@media (max-width: 640px) {
  .sm-h-banner {
    height: 210px;
    margin-top: 2rem;
    margin-left: 4rem;
  }
}
</style>
